import { Action } from 'redux';
import { VolumeDiscountMap, VolumeDiscountStep } from '@/types';

export enum DiscountsActionTypes {
  DISCOUNTS_SET_PRODUCT_TYPE = '@discounts/set/product-type',
  DISCOUNTS_SET_QUANTITY = '@discounts/set/quantity',
  DISCOUNTS_SUPPORTED = '@discounts/supported',
}

export interface DiscountsSetProductTypeAction extends Action {
  type: DiscountsActionTypes.DISCOUNTS_SET_PRODUCT_TYPE;
  productTypeId: string;
  discounts: VolumeDiscountStep[];
}

export interface DiscountsSetQuantityAction extends Action {
  type: DiscountsActionTypes.DISCOUNTS_SET_QUANTITY;
  quantity: number;
  discounts: VolumeDiscountMap;
}

export interface DiscountsSupportedData {
  contextId: string;
  productTypeId: string;
  supported: boolean;
}

export interface DiscountsSupportedAction extends Action {
  type: DiscountsActionTypes.DISCOUNTS_SUPPORTED;
  payload: DiscountsSupportedData[];
}

export type DiscountsActions =
  | DiscountsSetProductTypeAction
  | DiscountsSetQuantityAction
  | DiscountsSupportedAction;

export interface DiscountState {
  quantity: Record<string /* quantity */, VolumeDiscountMap>;
  productType: Record<string /* productTypeId */, VolumeDiscountStep[]>;
  supported: Record<string /* contextId-productTypeId */, boolean>;
}
